import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Events } from "../action/EventAction";
import dayjs, { Dayjs } from "dayjs";
// import { events } from "react-horizontal-scrolling-menu/dist/types/constants";

interface SelectedProgram {
  program_title: string;
  program_id: string;
}

interface EventsState {
  events: Events[];
  selectedValues: SelectedProgram[];
  currentDate: Dayjs; // store ISO string
}

const initialState: EventsState = {
  events: [],
  selectedValues: [],
  currentDate: dayjs(), // ✔ ISO string
};


const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setEventss(state, action: PayloadAction<Events[]>) {
      state.events = action.payload;
    },
    setSelectedValues(state, action: PayloadAction<SelectedProgram[]>) {
      state.selectedValues = action.payload;
    },
    setCurrentDates(state, action: PayloadAction<Dayjs>) {
      state.currentDate = action.payload; // Add `setCurrentDate` reducer
    },
    clearEvents(state) {
      state.events = [];
      state.selectedValues = [];
    },
  },
});

export const { setEventss, setSelectedValues, setCurrentDates, clearEvents } =
  eventsSlice.actions;
export default eventsSlice.reducer;
